import { SVGProps } from 'react';

export const CloseIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M0.466701 9.66311C0.348148 9.66311 0.229596 9.61802 0.139524 9.52727C-0.0412995 9.34644 -0.0412995 9.05328 0.139524 8.87246L8.21328 0.798703C8.3941 0.61788 8.68726 0.61788 8.86808 0.798703C9.04891 0.979527 9.04891 1.27269 8.86808 1.45362L0.794443 9.52727C0.703692 9.61745 0.58514 9.66311 0.466701 9.66311Z"
        fill="black"
      />
      <path
        d="M8.54102 9.66311C8.42247 9.66311 8.30403 9.61802 8.21384 9.52727L0.139524 1.45362C-0.0412995 1.27269 -0.0412995 0.979527 0.139524 0.798703C0.320347 0.61788 0.613506 0.61788 0.794443 0.798703L8.86808 8.87246C9.04891 9.05328 9.04891 9.34644 8.86808 9.52727C8.77733 9.61745 8.65889 9.66311 8.54102 9.66311Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath>
        <rect width="9" height="9" fill="white" transform="translate(0 0.663086)" />
      </clipPath>
    </defs>
  </svg>
);
